import { 
  Shield, 
  BarChart2, 
  RefreshCcw, 
  Bell,
  Clock,
  FileCheck
} from "lucide-react";

const features = [
  {
    icon: <Shield className="h-8 w-8 text-primary" />,
    title: "Risk Assessment",
    description: "Automated risk identification and mitigation recommendations"
  },
  {
    icon: <BarChart2 className="h-8 w-8 text-primary" />,
    title: "Real-time Analytics",
    description: "Comprehensive dashboards with actionable insights"
  },
  {
    icon: <RefreshCcw className="h-8 w-8 text-primary" />,
    title: "Continuous Monitoring",
    description: "24/7 compliance monitoring and instant alerts"
  },
  {
    icon: <Bell className="h-8 w-8 text-primary" />,
    title: "Smart Alerts",
    description: "Intelligent notifications for compliance updates"
  },
  {
    icon: <Clock className="h-8 w-8 text-primary" />,
    title: "Audit Ready",
    description: "Always prepared with automated documentation"
  },
  {
    icon: <FileCheck className="h-8 w-8 text-primary" />,
    title: "Policy Management",
    description: "Centralized policy creation and distribution"
  }
];

export const Features = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight">
            Comprehensive Compliance Management
          </h2>
          <p className="mt-4 text-lg text-gray-500">
            Everything you need to maintain compliance and reduce risk
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="feature-card p-6">
              <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-500">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};